import { captureError } from '@/Utils/Sentry/captureErrorSentry';
import lmsClient from '@/http/lms';

const ENDPOINT = 'quizzes';

const state = {
  quizWalletV2: {},
  walletSelected: {},
  quetionsAnswers: [],
  patrimony: false,
  approvedFunds: {},
};

const getters = {
  walletSelected: (state) => state.walletSelected,
  answers: (state) => state.quetionsAnswers,
  patrimony: (state) => state.patrimony,
};

const mutations = {
  SET_WALLETV2_QUIZ(state, quizWalletV2) {
    state.quizWalletV2 = quizWalletV2;
  },
  SET_WALLETV2(state, wallet) {
    state.walletSelected = wallet;
  },
  SET_QUESTIONS_ANSWERS_WALLETV2(state, questionsAnwsers) {
    state.quetionsAnswers = questionsAnwsers;
  },
  SET_APPROVED_FUNDS(state, funds) {
    state.approvedFunds = funds;
  },
  CLEAR_STATE(state) {
    state.quizWalletV2 = {};
    state.walletSelected = {};
    state.approvedFunds = {};
    state.quetionsAnswers = [];
    state.patrimony = false;
  },
  SET_PATRIMONY(state, patrimony) {
    state.patrimony = patrimony;
  },
};

const actions = {
  async getQuizWalletv2({ getters, commit }) {
    try {
      const response = await lmsClient.get(`${ENDPOINT}/${getters['walletSelected'].optionID}`);
      commit('SET_WALLETV2_QUIZ', response.data.data);
      return response.data;
    } catch (error) {
      console.error('## GPRIM ## error', error);
      captureError(error, 'error');
      return error?.response?.data;
    }
  },
  async setSelectedWallet({ commit }, wallet) {
    commit('SET_WALLETV2', wallet);
  },
  async setQuetionsAnswers({ commit }, questionsAnwsers) {
    commit('SET_QUESTIONS_ANSWERS_WALLETV2', questionsAnwsers);
  },
  async setPatrimony({ commit }, patrimony) {
    commit('SET_PATRIMONY', patrimony);
  },
  async clearState({ commit }) {
    commit('CLEAR_STATE');
  },
  async setApprovedFunds({ commit }, funds) {
    commit('SET_APPROVED_FUNDS', funds);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
